export const AwsConfigAuth = {
  region: process.env.REACT_APP_AUTH_REGION,
  userPoolId: process.env.REACT_APP_AUTH_USER_POOL_ID ?? "",
  userPoolClientId: process.env.REACT_APP_AUTH_USER_POOL_CLIENT_ID ?? "",
  mandatorySignIn: true,
  oauth: {
    domain: process.env.REACT_APP_AUTH_DOMAIN,
    scope: ["email", "openid", "phone"],
    redirectSignIn: `${window.location.origin}${process.env.REACT_APP_AUTH_REDIRECT_SIGNIN}`,
    redirectSignOut: `${window.location.origin}${process.env.REACT_APP_AUTH_REDIRECT_SIGNOUT}`,
    responseType: "code",
  },
  authenticationFlowType: "USER_SRP_AUTH",
};

export const sha256 = async (str: string) => {
  return await crypto.subtle.digest("SHA-256", new TextEncoder().encode(str));
};

export const generateNonce = async () => {
  const hash = await sha256(
    crypto.getRandomValues(new Uint32Array(4)).toString()
  );
  // https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/digest
  const hashArray = Array.from(new Uint8Array(hash));
  return hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
};

// export const base64URLEncode = (str: ArrayBuffer) => {
//   return  btoa(String.fromCharCode.apply(null, new Uint8Array(str)))
//     .replace(/\+/g, "-")
//     .replace(/\//g, "_")
//     .replace(/=+$/, "");
// };

export const parseJwt = (token: string) => {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload);
}